import React, { useEffect, useState, useContext } from "react";
import "./Features2.css";

import feature1Video from "../../../../assets/images/mhero2/features/MHERO II Adaptive ABS Adjustment.mp4";
import feature2Video from "../../../../assets/images/mhero2/features/MHERO II External Discharge Display.mp4";
import feature3Video from "../../../../assets/images/mhero2/features/MHERO II Low-Speed Off-road Assistance.mov";
import feature4Video from "../../../../assets/images/mhero2/features/MHERO II Off-Road Expert Mode.mp4";

import { LanguageContext } from "../../../../context/LanguageContext";
import { getPageContent } from "../../../../api/publicContent.api";

const HARDCODED_MEDIA = [
  { media: feature1Video, isVideo: true },
  { media: feature2Video, isVideo: true },
  { media: feature3Video, isVideo: true },
  { media: feature4Video, isVideo: true },
];

const FALLBACK_TAB_TITLES = [
  "Adaptive ABS Adjustment",
  "External Discharge Display",
  "Low-Speed Off-road Assistance",
  "Off-Road Expert Mode",
];

const buildFeatureItems = (features, featureTabs) => {
  const items = HARDCODED_MEDIA.map((item, index) => {
    const n = index + 1;
    const title =
      featureTabs?.[`tab_${n}`] ||
      features?.[`feature_${n}_title`] ||
      FALLBACK_TAB_TITLES[index] ||
      "";

    return {
      ...item,
      title,
    };
  }).filter((item) => item.title);

  return items.length
    ? items
    : HARDCODED_MEDIA.map((item, index) => ({
        ...item,
        title: FALLBACK_TAB_TITLES[index],
      }));
};

const Features2 = () => {
  const { currentLang } = useContext(LanguageContext);

  const [features, setFeatures] = useState(null);
  const [active, setActive] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFeatures = async () => {
      try {
        setLoading(true);

        const response = await getPageContent("mhero2", currentLang);
        const sections = response.sections || {};
        const items = buildFeatureItems(
          sections.features,
          sections.feature_tabs
        );

        setFeatures({
          title: sections.features?.features_title || "Key Features",
          items,
        });
      } catch (err) {
        console.error("Failed to load MHERO2 features", err);
      } finally {
        setLoading(false);
      }
    };

    loadFeatures();
  }, [currentLang]);

  if (loading || !features) return null;

  const current = features.items[active];

  return (
    <section className="features">
      <h2 className="features-title">{features.title}</h2>
      <span className="features-line" />

      <div className="features-tabs">
        {features.items.map((item, index) => (
          <div
            key={index}
            className={`feature-tab ${active === index ? "active" : ""}`}
            onClick={() => setActive(index)}
          >
            <p>{item.title}</p>
          </div>
        ))}
      </div>

      <div className="features-media">
        {current.isVideo ? (
          <video
            key={active}
            src={current.media}
            className="features-media-video"
            aria-label={current.title}
            autoPlay
            muted
            loop
            playsInline
          />
        ) : (
          <img
            src={current.media}
            alt={current.title}
            className="features-media-image"
          />
        )}
      </div>
    </section>
  );
};

export default Features2;
